goog.provide('gcm.xmlutil');
/**
 *
 * XmlUtil (<b>com.openbet.gcm.xmlutil</b>) provides utility
 * functions for dealing with XML from FOG and RGI.
 *
 * A game can optionally use these functions
 * to convert xml strings from FOG/RGI into objects in the correct
 * format for interacting with the GCM APIs.<br>
 * This functionality is exposed in com.openbet.gcm.xmlutil.
 *
 * @author xliu
 * @namespace
 */
var XmlUtil = {};

/**
 *
 * This function will parse FOG account XML node and FreebetSummary node
 * into an accountInfo object and a balances object as required by GCM
 * APIs.
 * The account node should look like this:<br>
 * <pre>
 *   &lt;Account balance="1000.00"
 *            ccy_code="GBP"
 *            held_funds=""
 *            adjusted_free_balance="No"
 *            ccy_decimal_separator="."
 *            ccy_thousand_separator=","/&gt;
 * </pre>
 * The FreebetSummary node should look like this:<br>
 * </pre>
 * &lt;FreebetSummary available_balance="1000.00" num_tokens="200"/&gt;
 * </pre>
 * @param {string} accountXml The xml text of Account node as in example.
 *                     This can be found in FOG response.
 * @param {string} freebetSummaryXml (Optional) The xml text of FreebetSummary node as
 *                     in example. This can be found in FOG response.
 *                     This parameter is optional.
 * @return {Object} The return value is an object combining accountInfo
 *                     and balances. It is in the format of:
 *                     {'accountInfo':{ ccy_code: 'GBP',
 *                                        ccy_decimal_separator: '.',
 *                                        ccy_thousand_separator: ','
 *                                      },
 *                     'balances':{
 *                                        'CASH': {amount: 1000},
 *                                        'FREEBET': {amount: 1000}
 *                                      }
 *                     }.
 * @throws Error if there is malformed XML or the required xml attributes
 *         are not found
 **/
XmlUtil.getAccountInfoAndBalancesFromFOGXml = function(accountXml, freebetSummaryXml) {
  if ( window.DOMParser ) { // Standard
      var xmlParser = new DOMParser();
      var xmlData = xmlParser.parseFromString( accountXml , "text/xml" );
  } else { // IE
      xmlData = new ActiveXObject( "Microsoft.XMLDOM" );
      xmlData.async = "false";
      xmlData.loadXML( accountXml );
  }

  var warnArr = [];
  try {
    var accountNode = xmlData.getElementsByTagName('Account')[0];
    var ccyCode = accountNode.getAttribute('ccy_code');
    if (ccyCode == null) warnArr.push('ccyCode');
    var ccyDecimalSeparator = accountNode.getAttribute('ccy_decimal_separator');
    if (ccyDecimalSeparator == null) warnArr.push('ccyDecimalSeparator');
    var ccyThousandSeparator = accountNode.getAttribute('ccy_thousand_separator');
    if (ccyThousandSeparator == null) warnArr.push('ccyThousandSeparator');
    var balance = parseFloat(accountNode.getAttribute('balance'));
    if (isNaN(balance)) warnArr.push('balance');
  }
  catch (e) {
    throw Error('com.openbet.gcm.xmlutil.getAccountInfoAndBalancesFromFOGXml: cannot parse Account XML');
  }


  var freebets = null;
  if (goog.isDefAndNotNull(freebetSummaryXml)) {
    try {
      xmlData = xmlParser.parseFromString(freebetSummaryXml, 'text/xml');
      var freebetSummaryNode = xmlData.getElementsByTagName('FreebetSummary')[0];
      freebets = parseFloat(freebetSummaryNode.getAttribute('available_balance'));
      if (isNaN(freebets)) warnArr.push('freebets');
    }
    catch (e) {
      throw Error('com.openbet.gcm.xmlutil.getAccountInfoAndBalancesFromFOGXml: cannot parse FreebetSummary XML');
    }
  }

  if (warnArr.length > 0) {
    throw Error('com.openbet.gcm.xmlutil.getAccountInfoAndBalancesFromFOGXml: Missing Data from XML: ' +
                  warnArr.toString());
  }

  var accountObj = {
    'ccy_code': ccyCode,
    'ccy_decimal_separator': ccyDecimalSeparator,
    'ccy_thousand_separator': ccyThousandSeparator
  };

  var balancesObj = {};
  balancesObj['CASH'] = {'amount': balance};

  if (goog.isDefAndNotNull(freebets)) {
    balancesObj['FREEBET'] = {'amount': freebets};
  }

  return {'accountInfo': accountObj, 'balances': balancesObj};
};


/**
 * This function will parse RGI Customer XML node into a balances object and an
 * accountInfo object in the format required by GCM APIs.<br>
 * The expected Customer XML should be in the following format.<br>
 *<pre>
 * &lt;Customer cookie="" user_id="" ccy_code="GBP"
 *      ccy_decimal_separator="."
 *      ccy_thousand_separator=","
 *      affiliate=""&gt;
 *   &lt;Balance type="CASH" amount="1000.00"/&gt;
 *   &lt;Balance type="FREEBET" amount="2000.00"/&gt;
 * &lt;/Customer&gt;
 * </pre>
 * @param {string} customerXml The xml text of Customer node as in example.
 *                     This can be found in RGI response.
 * @return {Object} The return value is an object combining accountInfo
 *                     and balances. It is in the format of:
 *                     {'accountInfo':{ ccy_code: 'GBP',
 *                                        ccy_decimal_separator: '.',
 *                                        ccy_thousand_separator: ','
 *                                      },
 *                     'balances':{
 *                                        'CASH': {amount: 1000},
 *                                        'FREEBET': {amount: 2000}
 *                                      }
 *                     }.
 * @throws Error if there is malformed XML or the required xml attributes are not found
 * */
XmlUtil.getAccountInfoAndBalancesFromRGIXml = function(customerXml) {
    if ( window.DOMParser ) { // Standard
        var xmlParser = new DOMParser();
        var xmlData = xmlParser.parseFromString( customerXml , "text/xml" );
    } else { // IE
        var xmlData = new ActiveXObject( "Microsoft.XMLDOM" );
        xmlData.async = "false";
        xmlData.loadXML( customerXml );
    }
  var warnArr = [];
  try {    
    var cutomerNode = xmlData.getElementsByTagName('Customer')[0];
    var ccyCode = cutomerNode.getAttribute('ccy_code');
    if (ccyCode == null) warnArr.push('ccyCode');
    var ccyDecimalSeparator = cutomerNode.getAttribute('ccy_decimal_separator');
    if (ccyDecimalSeparator == null) warnArr.push('ccyDecimalSeparator');
    var ccyThousandSeparator = cutomerNode.getAttribute('ccy_thousand_separator');
    if (ccyThousandSeparator == null) warnArr.push('ccyThousandSeparator');
  }
  catch (e) {
    throw Error('com.openbet.gcm.xmlutil.getAccountInfoAndBalancesFromRGIXml: Error parsing XML');
  }

  var accountObj = {
    'ccy_code': ccyCode,
    'ccy_decimal_separator': ccyDecimalSeparator,
    'ccy_thousand_separator': ccyThousandSeparator
  };

  var balancesObj = {};
  var balanceNodes = cutomerNode.getElementsByTagName('Balance');
  if (balanceNodes.length == 0) warnArr.push('balances');
  for (var i = 0, node; node = balanceNodes[i]; i++)
  {
    balancesObj[node.getAttribute('type')] = {'amount': parseFloat(node.getAttribute('amount'))};
  }

  if (warnArr.length > 0) {
    throw Error('com.openbet.gcm.xmlutil.getAccountInfoAndBalancesFromRGIXml: Missing Data from XML: ' +
                warnArr.toString());
  }

  return {'accountInfo': accountObj, 'balances': balancesObj};
};

/**
 * This function will parse FOG Error XML node and return an errorInfo
 * object as required by the gcm handleServerError function.
 *  <pre>&lt;Error xml:lang='en-GB' type='WARNING'
 *  code='igf.db.customer.Customer.GUEST_CUTOFF_MSG'
 *          msg='Your free session is over. Please register as a member to continue playing.'/&gt;</pre>
 *
 * @param {string} errorXml The xml text of the error node as in example.
 *                    This can be found in the FOG response.
 *
 * @return {Object} return a object combined errorCode and errorMessage in
 *          following format:
 *          {
 *            errorCode: code,
 *            errorMessage: msg
 *          }.
 * @throws Error if there is malformed XML
 * */
XmlUtil.getErrorInfoFromFOGXml = function(errorXml) {
  var errorObject;

  try {
    if ( window.DOMParser ) { // Standard
        var xmlParser = new DOMParser();
        var xmlDoc = xmlParser.parseFromString( errorXml , "text/xml" );
    } else { // IE
        var xmlDoc = new ActiveXObject( "Microsoft.XMLDOM" );
        xmlDoc.async = "false";
        xmlDoc.loadXML( errorXml );
    }
    var rootNode = xmlDoc.getElementsByTagName('Error')[0];
    var errCode = rootNode.getAttribute('code');
    if (!errCode) {
        errCode = 'UNKNOWN';
    }
    var errMessage = rootNode.getAttribute('msg');
    if (!errMessage) {
        errMessage = 'An unexpected error has occurred. Please try again.';
    }
  }
  catch (e)
  {
    throw Error('com.openbet.gcm.xmlutil.getErrorInfoFromFOGXml: Error parsing XML');
  }

  errorObject = {
    'errorCode': errCode,
    'errorMessage': errMessage
  };

  return errorObject;
};

/**
 * This function will parse RGI Error XML node and return an errorInfo
 * object as required by the gcm handleServerError function.
 * The node should look like this:
 *          <pre>&lt;Error xml:lang='en-GB' type='INVALID_FUNDS'
 *          code='igf.games.Game.INSUFFICIENT_FUNDS_P1' action='VOID_TXN'
 *          display='SHOW' msg='You have insufficient funds to place stake'/&gt;</pre>.
 * @param {string} errorXml The error node returned from the RGI server.
 *          This can be found in the RGI response.
 * @return {Object} return a object combined errorCode and errorMessage in
 *          following format:
 *          {
 *            errorType : errType,
 *            errorCode: errCode,
 *            errorAction: errAction,
 *            errorDisplay : errDisplay,
 *            errorMessage: errMessage
 *          }.
 * @throws Error if there is malformed XML, or the required xml attributes are not found
 * */
XmlUtil.getErrorInfoFromRGIXml = function(errorXml) {
  var errorObject;
  var warnArr = [];

  try {

    if ( window.DOMParser ) { // Standard
        var xmlParser = new DOMParser();
        var xmlDoc = xmlParser.parseFromString( errorXml , "text/xml" );
    } else { // IE
        var xmlDoc = new ActiveXObject( "Microsoft.XMLDOM" );
        xmlDoc.async = "false";
        xmlDoc.loadXML( errorXml );
    }

    var rootNode = xmlDoc.getElementsByTagName('Error')[0];
    var errType = rootNode.getAttribute('type');
    if (errType == null) warnArr.push('ErrorType');
    var errCode = rootNode.getAttribute('code');
    if (errCode == null) warnArr.push('ErrorCode');
    var errAction = rootNode.getAttribute('action');
    if (errAction == null) warnArr.push('ErrorAction');
    var errDisplay = rootNode.getAttribute('display');
    if (errDisplay == null) warnArr.push('ErrorDisplay');
    var errMessage = rootNode.getAttribute('msg');
    if (errMessage == null) warnArr.push('ErrorMessage');
  }
  catch (e)
  {
    throw Error('com.openbet.gcm.xmlutil.getErrorInfoFromRGIXml: Error parsing XML');
  }

  if (warnArr.length > 0) {
    throw Error('com.openbet.gcm.xmlutil.getErrorInfoFromRGIXml: Missing Data from XML: ' + warnArr.toString());
  }

  errorObject = {
    'errorType' : errType,
    'errorCode': errCode,
    'errorAction': errAction,
    'errorDisplay' : errDisplay,
    'errorMessage': errMessage
  };

  return errorObject;
};
goog.exportSymbol('com.openbet.gcm.xmlutil.getAccountInfoAndBalancesFromFOGXml',
                    XmlUtil.getAccountInfoAndBalancesFromFOGXml);
goog.exportSymbol('com.openbet.gcm.xmlutil.getAccountInfoAndBalancesFromRGIXml',
                    XmlUtil.getAccountInfoAndBalancesFromRGIXml);
goog.exportSymbol('com.openbet.gcm.xmlutil.getErrorInfoFromFOGXml', XmlUtil.getErrorInfoFromFOGXml);
goog.exportSymbol('com.openbet.gcm.xmlutil.getErrorInfoFromRGIXml', XmlUtil.getErrorInfoFromRGIXml);